export const ErrorsText = {
    OUT_OF_TRACKINGS: 'Out of tracking limit',
};
